
































import { defineComponent, reactive, } from '@vue/composition-api'

declare interface RoomSizeItem {
  text: string;
  value: number;
}

export default defineComponent({
  
  setup(props, context) {

    const state = reactive<{
      roomSize: number;
      roomSizeItems: RoomSizeItem[],
    }>({
      roomSize: 2,
      roomSizeItems: [
        {
          text: '2',
          value: 2,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '4',
          value: 4,
        },
        {
          text: '5',
          value: 5,
        },              
      ]
    })

    function setRoomSize(): void {
      context.emit('setRoomSize', state.roomSize)
    }

    function cancel(): void {
      context.emit('cancel')
    }

    return {
      state,
      setRoomSize,
      cancel,
    }
  }
})
